// Shared tone tokens for the /trading page.
export const TONE = {
  orange: { hex: '#FFC107', rgb: '243,112,33' },
  green:  { hex: '#22c55e', rgb: '34,197,94' },
  blue:   { hex: '#3b82f6', rgb: '59,130,246' },
  purple: { hex: '#a855f7', rgb: '168,85,247' },
  cyan:   { hex: '#22d3ee', rgb: '34,211,238' },
}

export {}
